import { actionTypes } from 'actions/payment/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export function payment(state: any = initialState, action: any) {
  switch (action.type) {
    case actionTypes.POST_CHECKOUT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.POST_CHECKOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionTypes.POST_CHECKOUT_FAIL:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.error,
      };

    case actionTypes.CANCEL_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.CANCEL_SUBSCRIPTION_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
        };
    case actionTypes.CANCEL_SUBSCRIPTION_FAIL:
        return {
          ...state,
          loading: false,
          data: null,
          error: action.error,
    };


    case actionTypes.RESUME_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.RESUME_SUBSCRIPTION_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
        };
    case actionTypes.RESUME_SUBSCRIPTION_FAIL:
        return {
          ...state,
          loading: false,
          data: null,
          error: action.error,
    };

    case actionTypes.CLEAR_SUBSCRIPTION:
      return {
        loading: false,
        data: null,
        error: null,
      };
    default:
      return state;
  }
}
